/*
Controller: InventoryIngestion

Operations:
  getInventoryIngestionData
  createInventoryIngestion
  getInventoryIngestionById
  patchInventoryIngestion
  deleteInventoryIngestion
  updateInventoryIngestionStatus
  getInventoryIngestionSummary
  getFamiliesStyles
*/
var Api = require('../config')
var InventoryIngestionRequestDef = require('../definitions/InventoryIngestionRequest')
var PatchInventoryIngestionRequestDef = require('../definitions/PatchInventoryIngestionRequest')
var FamiliesStylesRequestDef = require('../definitions/FamiliesStylesRequest')

var InventoryIngestion = (function () {
  /*
  Operation: getInventoryIngestionData
  Get inventory ingestion status
  Parameters:
    search: search string
    sortBy: field to sort by, possible values: &#39;updated_at&#39;, &#39;created_at&#39;, &#39;ingestionName&#39;, &#39;foundryName&#39;, &#39;ownerName&#39;, &#39;status&#39;
    sortDirection: sortDirection to sort by, asc or desc
    page: page number, starting with 1
    perPage: number of items per page, max 50
    ingestionType: ingestion type, possible values: &#39;custom-fonts&#39;, &#39;non-custom-fonts&#39;
    status: status filter, possible values: &#39;in_progress&#39;, &#39;error&#39;, &#39;success&#39;, &#39;in_work&#39;, &#39;cancelled&#39;
    binariesStatus: binaries status filter, possible values: &#39;processing&#39;, &#39;saved&#39;, &#39;error&#39;
  Responses:
    HTTP 200: Inventory ingestion Data
    HTTP 400: Input error
    HTTP 403: Operation not permitted
  */
  function getInventoryIngestionDataInventoryIngestion (search, sortBy, sortDirection, page, perPage, ingestionType, status, binariesStatus) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['search'] = search
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['ingestionType'] = ingestionType
      parameters['status'] = status
      parameters['binariesStatus'] = binariesStatus
      var path = '/inventoryIngestion'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createInventoryIngestion
  Create inventory ingestion
  Parameters:
    bodyRequest: Inventory Ingestion Request
  Responses:
    HTTP 200: Valid response
    HTTP 400: Inventory Ingestion creation failed
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 409: Project name and MID combination already exists
  */
  function createInventoryIngestionInventoryIngestion (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        InventoryIngestionRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getInventoryIngestionById
  Get inventory ingestion
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
  Responses:
    HTTP 200: Inventory ingestion Data
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Ingestion not found
  */
  function getInventoryIngestionByIdInventoryIngestion (inventoryIngestionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: patchInventoryIngestion
  Patch inventory ingestion
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
    bodyRequest: Inventory Ingestion object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Inventory Ingestion update failed
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Inventory Ingestion not found
    HTTP 409: Project name and MID combination already exists
  */
  function patchInventoryIngestionInventoryIngestion (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        PatchInventoryIngestionRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'patch',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteInventoryIngestion
  Delete inventory ingestion
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
  Responses:
    HTTP 200: Success
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Inventory ingestion not found
  */
  function deleteInventoryIngestionInventoryIngestion (inventoryIngestionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateInventoryIngestionStatus
  Update inventory ingestion status
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
  Responses:
    HTTP 200: Status updated successfully
    HTTP 400: Status update failed
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Inventory Ingestion not found
  */
  function updateInventoryIngestionStatusInventoryIngestion (inventoryIngestionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/updateStatus'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'patch',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getInventoryIngestionSummary
  Get summary of the inventory ingestion
  Parameters:
    inventoryIngestionId: ID of the inventory ingestion
  Responses:
    HTTP 200: Inventory ingestion summary
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Inventory ingestion not found
  */
  function getInventoryIngestionSummaryInventoryIngestion (inventoryIngestionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/summary'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFamiliesStyles
  Get all the styles of a families of a inventory ingestion
  Parameters:
    inventoryIngestionId: ID of the inventory ingestion
    bodyRequest: Families styles request
  Responses:
    HTTP 200: Styles of families
    HTTP 400: Invalid request data
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Inventory ingestion not found
  */
  function getFamiliesStylesInventoryIngestion (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        FamiliesStylesRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/familiesStyles'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getInventoryIngestionData'] = getInventoryIngestionDataInventoryIngestion
  ret['createInventoryIngestion'] = createInventoryIngestionInventoryIngestion
  ret['getInventoryIngestionById'] = getInventoryIngestionByIdInventoryIngestion
  ret['patchInventoryIngestion'] = patchInventoryIngestionInventoryIngestion
  ret['deleteInventoryIngestion'] = deleteInventoryIngestionInventoryIngestion
  ret['updateInventoryIngestionStatus'] = updateInventoryIngestionStatusInventoryIngestion
  ret['getInventoryIngestionSummary'] = getInventoryIngestionSummaryInventoryIngestion
  ret['getFamiliesStyles'] = getFamiliesStylesInventoryIngestion
  return ret
})()

module.exports = InventoryIngestion
